<template>
  <div
    class="augmented-product-list"
    :style="{ background: initialdata.bgColor || defaultBgColor }"
  >
    <div v-if="!showfirstCTA && !showSecondCTA" class="main-page">
      <div class="heading" v-html="initialdata.heading"></div>
      <div class="subheading" v-html="initialdata.subheading"></div>
      <div class="cta-button-block">
        <button
          v-if="initialdata.ctalinkText != null"
          class="popin-cta-button"
          @click="showCTA('first')"
        >
          {{ initialdata.ctalinkText }}
        </button>
        <button
          v-if="initialdata.cta2Text != null"
          class="popin-cta-button"
          @click="showCTA('second')"
        >
          {{ initialdata.cta2Text }}
        </button>
      </div>
      <img
        v-if="initialdata.imageSrc != null"
        :src="initialdata.imageSrc"
        :alt="initialdata.imageAlt"
      />
    </div>
    <div v-else class="mctb_popup_03_ mctb-modal-mask" style="background-color: rgb(0 0 0 / 6%)">
      <div class="mctb_popup_04_ mctb-modal-wrapper">
        <div
          class="mctb_popup_05_ mctb-modal-container"
          style="box-shadow: 0 2px 8px rgb(0 0 0 / 5%)"
        >
          <div
            class="mctb_popup_06_ mctb-carousel-mode-header"
            :style="screenHeight"
            style="padding: 0"
          >
            <div v-if="showfirstCTA">
              <div
                v-for="(product, index) in initialdata.CTA1popin"
                :key="index"
                :style="{ background: product.bgColor }"
              >
                <div v-if="index == 0" class="close-icon-new" @click="showCTA('first')"></div>
                <div class="text-content" :style="{ padding: index == 0 ? '1rem 1rem' : '' }">
                  <div
                    class="heading"
                    :style="{ color: product.headingColor }"
                    v-html="product.heading"
                  ></div>
                  <div class="subheading" v-html="product.subheading"></div>
                  <div class="description" v-html="product.title"></div>
                </div>
                <img :src="product.imageSrc" :alt="product.imageAlt" />
              </div>
            </div>
            <div v-if="showSecondCTA">
              <div
                v-for="(item, item_index) in initialdata.CTA2popin"
                :key="item_index"
                :style="{ background: item.bgColor }"
              >
                <div v-if="item_index == 0" class="close-icon-new" @click="showCTA('second')"></div>
                <div class="text-content" :style="{ padding: index == 0 ? '1rem 1rem' : '' }">
                  <div
                    class="heading"
                    :style="{ color: item.headingColor }"
                    v-html="item.heading"
                  ></div>
                  <div class="subheading" v-html="item.subheading"></div>
                  <div class="description" v-html="item.title"></div>
                </div>
                <img :src="item.imageSrc" :alt="item.imageAlt" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'augmented-product-list',
  props: {
    initialdata: { type: Object, required: true },
  },
  data() {
    return {
      showfirstCTA: false,
      showSecondCTA: false,
      defaultBgColor: 'linear-gradient(180deg, #F9F9F9 0%, rgba(255, 255, 255, 0) 100%)',
    };
  },
  computed: {
    screenHeight() {
      return {
        height: window.innerHeight + 15 + 'px',
      };
    },
  },
  methods: {
    showCTA(value) {
      if (value == 'first') {
        this.showfirstCTA = !this.showfirstCTA;
      } else if (value == 'second') {
        this.showSecondCTA = !this.showSecondCTA;
      }
    },
  },
};
</script>
